import React from "react";

export default function AdminPanelIcon({ color = "white" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
      <path
        fill={color}
        fillRule="evenodd"
        d="M16.875 9.563l-2.45.408a6.146 6.146 0 0 1-.668 1.617l1.442 2.021-1.591 1.59-2.02-1.442c-.505.299-1.05.524-1.617.669l-.409 2.449h-2.25l-.408-2.45a6.146 6.146 0 0 1-1.617-.668l-2.02 1.442-1.59-1.591 1.442-2.02a6.146 6.146 0 0 1-.67-1.617L0 9.562v-2.25l2.45-.408c.144-.568.37-1.112.668-1.617l-1.442-2.02 1.591-1.59 2.02 1.442a6.146 6.146 0 0 1 1.617-.67L7.313 0h2.25l.408 2.45c.568.144 1.112.37 1.617.668l2.02-1.442L15.2 3.267l-1.443 2.02c.299.505.524 1.05.669 1.617l2.449.409v2.25zm-8.438 1.874a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
      />
    </svg>
  );
}
